/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aml_Toast_Reject_PnkInputs */

const vi_aml_toast_reject_pnk = /** @type {(inputs: Aml_Toast_Reject_PnkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã từ chối phiếu nhập kho`)
};

/**

* @param {Aml_Toast_Reject_PnkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const aml_toast_reject_pnk = /** @type {((inputs?: Aml_Toast_Reject_PnkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aml_Toast_Reject_PnkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_aml_toast_reject_pnk(inputs)
});